var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-default-appbar',{attrs:{"filterable":"","filters":_vm.filtros}},[_vm._v(" Apontamento Embarque ")])
}
var staticRenderFns = []

export { render, staticRenderFns }